module.exports = __webpack_public_path__ + "static/manufacturing_operational-a41f8c5b78f834a9755f82aa00756669.png";